// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../utils/Utils.bs.js");
let React = require("react");
let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let MenuV5 = require("../common/Components/menu/MenuV5.bs.js");
let Stdlib = require("@rescript/runtime/lib/js/Stdlib.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let NotificationSettingsUtils = require("./NotificationSettingsUtils.bs.js");
let NotificationSettingsComponents = require("./NotificationSettingsComponents.bs.js");
let NotificationPreferencesAreasInputV5 = require("../../reason/settings/components/NotificationPreferencesAreasInputV5.bs.js");
let NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.bs.js");
let NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.bs.js");
let NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.bs.js");
let NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.bs.js");

function NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypeDisplayGroup(props) {
  let areas = props.areas;
  if (areas.length !== 0) {
    return JsxRuntime.jsx(NotificationSettingsComponents.AreaTypesList.make, {
      areas: areas,
      areaType: props.areaType,
      onRemoveArea: props.onRemoveArea,
      showCount: false,
      style: props.style
    });
  } else {
    return null;
  }
}

let AreaTypeDisplayGroup = {
  make: NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypeDisplayGroup
};

let convertFragment = NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.node, convertFragment, fRef);
}

let ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function NotificationSettingsPreferenceEditDialogAreaGroups$AreaGroupOption(props) {
  let entityType = props.entityType;
  let areaGroup = props.areaGroup;
  let chapter = RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialogAreaGroupsOption_chapter_graphql.node, convertFragment, props.chapter);
  let tmp;
  switch (areaGroup.TAG) {
    case "UserAreaGroup" :
      tmp = areaGroup.usedFor;
      break;
    case "ChapterAreaGroup" :
    case "NewAreaGroup" :
      tmp = [entityType];
      break;
  }
  let notificationTypes = NotificationSettingsUtils.notificationTypesString(tmp);
  switch (areaGroup.TAG) {
    case "UserAreaGroup" :
      return `My custom ` + notificationTypes + ` areas`;
    case "ChapterAreaGroup" :
      return `My chapter (` + chapter.displayName + `) areas`;
    case "NewAreaGroup" :
      return `Create new custom areas for ` + notificationTypes;
  }
}

let AreaGroupOption = {
  ChapterFragment: ChapterFragment,
  make: NotificationSettingsPreferenceEditDialogAreaGroups$AreaGroupOption
};

function mapCensusPlaceTypeToCityType(x) {
  if (x === "CENSUS_PLACE") {
    return "CITY";
  } else {
    return x;
  }
}

function NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypesDisplayer(props) {
  let style = props.style;
  let onRemoveArea = props.onRemoveArea;
  let areas = props.areas;
  let areaTypes = [
    "STATE",
    "COUNTY",
    "CITY",
    "TOWNSHIP",
    "NEIGHBORHOOD",
    "ZIP_CODE",
    "SCHOOL_DISTRICT",
    "SCHOOL",
    "BLOCK_GROUP",
    "CENSUS_PLACE"
  ];
  return JsxRuntime.jsx("div", {
    children: areaTypes.map(areaType => JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypeDisplayGroup, {
      areas: areas.filter(a => mapCensusPlaceTypeToCityType(a.type_) === areaType),
      areaType: areaType,
      onRemoveArea: onRemoveArea,
      style: style
    }, areaType)),
    className: "flex flex-col gap-4"
  });
}

let AreaTypesDisplayer = {
  make: NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypesDisplayer
};

let convertFragment$1 = NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.node, convertFragment$1, fRef);
}

let ChapterFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let areaTypeV5_decode = NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.Utils.areaTypeV5_decode;

let matchableEntityType_decode = NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.Utils.matchableEntityType_decode;

let convertFragment$2 = NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.node, convertFragment$2, fRef);
}

let SettingsFragment_areaTypeV5_fromString = NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.Utils.areaTypeV5_fromString;

let SettingsFragment_matchableEntityType_fromString = NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.Utils.matchableEntityType_fromString;

let SettingsFragment = {
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: SettingsFragment_areaTypeV5_fromString,
  matchableEntityType_decode: matchableEntityType_decode,
  matchableEntityType_fromString: SettingsFragment_matchableEntityType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

let convertFragment$3 = NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.node, convertFragment$3, fRef);
}

let AreaGroupFragment_areaTypeV5_decode = NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.Utils.areaTypeV5_decode;

let AreaGroupFragment_areaTypeV5_fromString = NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.Utils.areaTypeV5_fromString;

let AreaGroupFragment = {
  areaTypeV5_decode: AreaGroupFragment_areaTypeV5_decode,
  areaTypeV5_fromString: AreaGroupFragment_areaTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function notificationTypeSortWeight(nlist) {
  return Stdlib_Array.reduce(nlist.map(x => {
    switch (x) {
      case "BUYER_NEED" :
        return -10;
      case "FOR_SALE_PROPERTY" :
        return -1000;
      case "RENTAL_NEED" :
        return -1;
      case "RENTAL_PROPERTY" :
        return -100;
    }
  }), 0, (prim0, prim1) => prim0 + prim1 | 0);
}

function NotificationSettingsPreferenceEditDialogAreaGroups(props) {
  let fieldResult = props.fieldResult;
  let preferenceType = props.preferenceType;
  let setAreaGroup = props.setAreaGroup;
  let currentAreaGroup = props.currentAreaGroup;
  let settings = RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialogAreaGroups_settings_graphql.node, convertFragment$2, props.settings);
  let match = React.useState(() => Object.fromEntries(Stdlib_Option.getOr(settings.userAreaGroups, []).map(areaGroup => [
    areaGroup.id,
    {
      TAG: "UserAreaGroup",
      id: areaGroup.id,
      areas: Stdlib_Array.filterMap(Stdlib_Array.keepSome(Stdlib_Option.getOr(areaGroup.areas, [])), a => Stdlib_Option.map(areaTypeV5_decode(a.type_), t => ({
        id: a.id,
        label: a.label,
        type_: t
      }))),
      usedFor: Stdlib_Array.filterMap(Stdlib_Option.getOr(areaGroup.usedFor, []), v => matchableEntityType_decode(v))
    }
  ])));
  let existingCustomAreaGroups = match[0];
  let setAreaGroup$1 = areaGroup => {
    let areaGroupId = NotificationSettingsUtils.getAreaGroupId(areaGroup);
    existingCustomAreaGroups[areaGroupId] = areaGroup;
    setAreaGroup(areaGroup);
  };
  let chapter = RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialogAreaGroups_chapter_graphql.node, convertFragment$1, props.chapter);
  let match$1 = chapter.notificationPreferences;
  let fRef;
  switch (preferenceType) {
    case "BUYER_NEED" :
      if (match$1 !== undefined) {
        let match$2 = match$1.buyerNeeds;
        fRef = match$2 !== undefined ? match$2.areaGroup.fragmentRefs : Stdlib.panic("Expected a chapter default area group to exist for the given entity type.");
      } else {
        fRef = Stdlib.panic("Expected a chapter default area group to exist for the given entity type.");
      }
      break;
    case "FOR_SALE_PROPERTY" :
      if (match$1 !== undefined) {
        let match$3 = match$1.forSaleProperties;
        fRef = match$3 !== undefined ? match$3.areaGroup.fragmentRefs : Stdlib.panic("Expected a chapter default area group to exist for the given entity type.");
      } else {
        fRef = Stdlib.panic("Expected a chapter default area group to exist for the given entity type.");
      }
      break;
    case "RENTAL_NEED" :
      if (match$1 !== undefined) {
        let match$4 = match$1.rentalNeeds;
        fRef = match$4 !== undefined ? match$4.areaGroup.fragmentRefs : Stdlib.panic("Expected a chapter default area group to exist for the given entity type.");
      } else {
        fRef = Stdlib.panic("Expected a chapter default area group to exist for the given entity type.");
      }
      break;
    case "RENTAL_PROPERTY" :
      if (match$1 !== undefined) {
        let match$5 = match$1.rentalProperties;
        fRef = match$5 !== undefined ? match$5.areaGroup.fragmentRefs : Stdlib.panic("Expected a chapter default area group to exist for the given entity type.");
      } else {
        fRef = Stdlib.panic("Expected a chapter default area group to exist for the given entity type.");
      }
      break;
  }
  let chapterDefaultAreaGroup = RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup_graphql.node, convertFragment$3, fRef);
  let chapterDefaultAreaGroup_0 = chapterDefaultAreaGroup.id;
  let chapterDefaultAreaGroup_1 = Stdlib_Array.filterMap(Stdlib_Array.keepSome(Stdlib_Option.getOr(chapterDefaultAreaGroup.areas, [])), v => Stdlib_Option.map(areaTypeV5_decode(v.type_), t => ({
    id: v.id,
    label: v.label,
    type_: t
  })));
  let chapterDefaultAreaGroup$1 = {
    TAG: "ChapterAreaGroup",
    id: chapterDefaultAreaGroup_0,
    areas: chapterDefaultAreaGroup_1
  };
  let areaGroupOptions = Utils.$$Array.uniq(Belt_Array.concatMany([
    [
      chapterDefaultAreaGroup$1,
      currentAreaGroup
    ],
    Object.values(existingCustomAreaGroups)
  ]), NotificationSettingsUtils.getAreaGroupId);
  areaGroupOptions.sort((a, b) => {
    switch (a.TAG) {
      case "UserAreaGroup" :
        switch (b.TAG) {
          case "UserAreaGroup" :
            if (notificationTypeSortWeight(a.usedFor) < notificationTypeSortWeight(b.usedFor)) {
              return -1;
            } else {
              return 1;
            }
          case "ChapterAreaGroup" :
            return 1;
          case "NewAreaGroup" :
            return 0;
        }
      case "ChapterAreaGroup" :
        switch (b.TAG) {
          case "UserAreaGroup" :
            return -1;
          case "ChapterAreaGroup" :
          case "NewAreaGroup" :
            return 0;
        }
      case "NewAreaGroup" :
        return 0;
    }
  });
  let match$6 = areaGroupOptions.find(v => {
    switch (v.TAG) {
      case "UserAreaGroup" :
        let match = v.usedFor;
        if (match.length !== 1) {
          return false;
        }
        let n = match[0];
        return n === preferenceType;
      case "ChapterAreaGroup" :
      case "NewAreaGroup" :
        return false;
    }
  });
  if (match$6 === undefined) {
    let tmp;
    switch (currentAreaGroup.TAG) {
      case "UserAreaGroup" :
      case "ChapterAreaGroup" :
        tmp = currentAreaGroup.areas;
        break;
      case "NewAreaGroup" :
        tmp = currentAreaGroup.areas;
        break;
    }
    areaGroupOptions.push({
      TAG: "NewAreaGroup",
      areas: tmp
    });
  }
  let tmp$1;
  switch (currentAreaGroup.TAG) {
    case "UserAreaGroup" :
      let usedFor = currentAreaGroup.usedFor;
      tmp$1 = usedFor.includes(preferenceType) ? "This is the custom area group you set for your " + (Utils.$$String.enumerate(Stdlib_List.fromArray(usedFor.map(NotificationSettingsUtils.toDisplayStringSingular))) + " filters. Any changes you make will apply everywhere this filter is in place.") : "You've selected your custom area group for " + (Utils.$$String.enumerate(Stdlib_List.fromArray(usedFor.map(NotificationSettingsUtils.toDisplayStringSingular))) + (" filters. Click Save Changes to also use these areas for " + (NotificationSettingsUtils.toDisplayStringPlural(preferenceType) + ".")));
      break;
    case "ChapterAreaGroup" :
      tmp$1 = "These are the default areas for your chapter. To customize the areas you receive emails about, select a custom area group from the dropdown.";
      break;
    case "NewAreaGroup" :
      tmp$1 = "You are creating a new custom area group for " + (NotificationSettingsUtils.toDisplayStringPlural(preferenceType) + ". Once you have saved your changes you can use this area group with other filters, too.");
      break;
  }
  let tmp$2;
  let exit = 0;
  let areas;
  switch (currentAreaGroup.TAG) {
    case "UserAreaGroup" :
      areas = currentAreaGroup.areas;
      exit = 1;
      break;
    case "ChapterAreaGroup" :
      tmp$2 = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypesDisplayer, {
          areas: currentAreaGroup.areas,
          style: "Minimal"
        }),
        className: "mt-2"
      });
      break;
    case "NewAreaGroup" :
      areas = currentAreaGroup.areas;
      exit = 1;
      break;
  }
  if (exit === 1) {
    let tmp$3;
    tmp$3 = fieldResult !== undefined && fieldResult.TAG !== "Ok" ? "error" : undefined;
    tmp$2 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(NotificationPreferencesAreasInputV5.make, {
          onChange: area => {
            if (area === undefined) {
              return;
            }
            let newAreas = areas.slice();
            newAreas.push({
              id: area.id,
              label: area.label,
              type_: area.type_
            });
            let tmp;
            switch (currentAreaGroup.TAG) {
              case "UserAreaGroup" :
                tmp = {
                  TAG: "UserAreaGroup",
                  id: currentAreaGroup.id,
                  areas: newAreas,
                  usedFor: currentAreaGroup.usedFor
                };
                break;
              case "ChapterAreaGroup" :
                tmp = currentAreaGroup;
                break;
              case "NewAreaGroup" :
                tmp = {
                  TAG: "NewAreaGroup",
                  areas: newAreas
                };
                break;
            }
            setAreaGroup$1(tmp);
          },
          status: tmp$3,
          excludeItemFn: area => Stdlib_Option.isNone(areas.find(a => a.id === area.id))
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups$AreaTypesDisplayer, {
            areas: areas,
            onRemoveArea: areaId => {
              let newAreas = areas.filter(area => area.id !== areaId);
              let tmp;
              switch (currentAreaGroup.TAG) {
                case "UserAreaGroup" :
                  tmp = {
                    TAG: "UserAreaGroup",
                    id: currentAreaGroup.id,
                    areas: newAreas,
                    usedFor: currentAreaGroup.usedFor
                  };
                  break;
                case "ChapterAreaGroup" :
                  tmp = currentAreaGroup;
                  break;
                case "NewAreaGroup" :
                  tmp = {
                    TAG: "NewAreaGroup",
                    areas: newAreas
                  };
                  break;
              }
              setAreaGroup$1(tmp);
            }
          }),
          className: "mt-4"
        })
      ]
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: "Areas",
        className: "font-semibold text-lg text-gray-900"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(MenuV5.Menu.make, {
            button: JsxRuntime.jsxs(ButtonsV5.Button.make, {
              className: "!font-normal !normal-case !py-2 flex item-center justify-between gap-4",
              children: [
                JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups$AreaGroupOption, {
                  areaGroup: currentAreaGroup,
                  chapter: chapter.fragmentRefs,
                  entityType: preferenceType
                }),
                JsxRuntime.jsx(IconV5.make, {
                  icon: "arrow-down",
                  size: 14,
                  className: "text-gray-500"
                })
              ]
            }),
            children: areaGroupOptions.map(areaGroup => JsxRuntime.jsx(MenuV5.MenuItem.make, {
              onAction: () => setAreaGroup$1(areaGroup),
              children: JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups$AreaGroupOption, {
                areaGroup: areaGroup,
                chapter: chapter.fragmentRefs,
                entityType: preferenceType
              })
            }, NotificationSettingsUtils.getAreaGroupId(areaGroup)))
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: tmp$1,
              className: "italic p-2 pl-0 mt-2 text-gray-500"
            })
          }),
          JsxRuntime.jsx("div", {
            children: tmp$2
          }),
          JsxRuntime.jsx(Form__Components.FieldErrorV2.make, {
            valid: fieldResult
          })
        ],
        className: "p-2"
      })
    ],
    className: "p-4"
  });
}

let make = NotificationSettingsPreferenceEditDialogAreaGroups;

exports.AreaTypeDisplayGroup = AreaTypeDisplayGroup;
exports.AreaGroupOption = AreaGroupOption;
exports.mapCensusPlaceTypeToCityType = mapCensusPlaceTypeToCityType;
exports.AreaTypesDisplayer = AreaTypesDisplayer;
exports.ChapterFragment = ChapterFragment$1;
exports.SettingsFragment = SettingsFragment;
exports.AreaGroupFragment = AreaGroupFragment;
exports.notificationTypeSortWeight = notificationTypeSortWeight;
exports.make = make;
/* Utils Not a pure module */
